












































































import {
  Component, Vue,
} from 'vue-property-decorator';
import CustomSummaryViewModel
  from
  '@/vue-app/view-models/components/goals-dashboard/create-goal/custom/custom-summary-view-model';

@Component({
  name: 'CustomSummary',
  components: {
    CustomTooltip: () => import('@/vue-app/components/custom/CustomTooltip.vue'),
  },
})
export default class CustomSummary extends Vue {
  view_model = Vue.observable(
    new CustomSummaryViewModel(this),
  );

  created() {
    this.view_model.initialize();
  }
}
